import { jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Shape } from "three";
const Extrude = memo(function ShapeMesh({
  points,
  extrude,
  ...props
}) {
  const shape = useMemo(() => {
    const shape2 = new Shape();
    for (let i = 0; i < points.length; i++) {
      let p = points[i];
      if ("isVector2" in p) {
        p = [p.x, p.y];
      }
      if (i === 0)
        shape2.moveTo(p[0], p[1]);
      else {
        shape2.lineTo(p[0], p[1]);
      }
    }
    shape2.closePath();
    return shape2;
  }, [points]);
  return /* @__PURE__ */ jsx("mesh", { ...props, children: /* @__PURE__ */ jsx("extrudeGeometry", { args: [shape, extrude] }) });
});
Extrude.displayName = "Shape";
export {
  Extrude
};
//# sourceMappingURL=index45.js.map
